import CustomHead from "./CustomHead";

export default CustomHead;
